module.exports = __webpack_public_path__ + "static/img/verCodeImg4.219382d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verCodeImg4.png
// module id = wH8L
// module chunks = 7